//TODO: Fix spacing between .notchTrigger, it fires callout incorrectly sometimes, since the spacing between triggers is different depending on the number of notches.
(function ($) {
    "use strict";
    /* Slider defaults */
    var defaults = {
        customClasses: "",
        notchCount: 4,
        notchWidth: "auto", /* Set if the handle should scale to the relative size of the track � notches */
        handleAnimationTime: 120, /* Time in milliseconds. */
        handleAnimationType: "linear", /* Default to jquerys auto animation type. Options are any available jquery/jquery UI* animation */
        startingNotch: 2,
        notchChange: function(newNotchIndex) {}
    };

    $.fn.slider = function (options) {
        return this.each(function () {
            var $this = $(this),
                $handle,
                startingNotch,
                currentNotchIndex,
                settings = $.extend({}, defaults, options);
            //Determine what the notch length should be based on array or number passed back.
            function initSettings() {
                settings.notchData = settings.notchCount;
                if (typeof settings.notchCount === "object") {
                    settings.notchCount = settings.notchCount.length;
                } else if (typeof settings.notchCount === "number") {
                    settings.notchCount = settings.notchCount;
                } else {
                    console.warn("notchCount must be array or number");
                }
                return settings.notchCount;
            }

            function createTrack() {
                $this.addClass("sliderDirective");
                return $this.data("slider-track", $("<div class='track'></div>")
                    .appendTo($this));
            }

            function createTrackCover() {
                return $this.data("slider-trackCover", $("<div class='trackCover'></div>")
                    .appendTo($this));
            }

            function isNotchDataAvailable(i) {
                return typeof settings.notchData[i] !== "undefined" &&
                    typeof settings.notchData[i].value !== "undefined" &&
                    settings.notchData[i] !== null &&
                    settings.notchData[i].value !== null;
            }

            function createTriggerNotchesForCallouts() {
                var notchContent = "",
                    i,
                    label = "",
                    notchPosition = 0;
                if (settings.notchCount > 1) {
                    //Loop through notch count to determine how far apart to position each notch.
                    //Add label for callouts
                    for (i = 0; i < settings.notchCount; i++) {
                        if (isNotchDataAvailable(i)) {
                            label = settings.notchData[i].label;
                        }
                        notchContent += '<div class="notchTrigger calloutTriggerNoArrow" style="left:' + notchPosition + '%; width:' + (100 / settings.notchCount) + '%; margin-left:-' + (100 / settings.notchCount / 2) + 'px;" data-callout="' + label + '"></div>';
                        notchPosition += 100 / (settings.notchCount - 1);
                    }
                }
                $this.prepend(notchContent);
            }

            function createNotches() {
                var notchContent = "",
                    i,
                    notchPosition = 0;
                //Set the starting notch, used for determining handle color     
                startingNotch = $this.find(".notch:eq(" + settings.startingNotch + ")");
                if (settings.notchCount > 1) {
                    //Loop through notch count to determine how far apart to position each notch.
                    //Add value and title to the input for use when updating the filters
                    for (i = 0; i < settings.notchCount; i++) {
                        notchContent += '<div class="notch vHidden" style="left:' + notchPosition + '%;"></div>';
                        notchPosition += 100 / (settings.notchCount - 1);
                    }
                } else {
                    $this.css("opacity", "0.5");
                    $this.off();
                    console.warn("Notch count must be 2 or more");
                }
                return $this.data("slider-notches", $(notchContent)
                    .appendTo($this)).first().addClass("notchComp");
            }

            function createHandle() {
                var handleWidth;
                if (settings.notchWidth !== "small") {
                    handleWidth = ($this.width() / settings.notchCount + 10);
                } else {
                    handleWidth = 27;
                }
                return $this.data("slider-handle", $("<button class='handle ancBtn tin silver calloutTriggerNoArrow'></button>")
                    .css({ "width": handleWidth, "margin-left": -handleWidth / 2 + $(".notch").width() / 2 - 3 + "px" })
                    .appendTo($this)
                    .data("slider-default-position", settings.startingNotch));
            }

            function initHandlePosition(e) {
                $handle = $this.find(".handle");
                //Should we get the value from settings.startingNotch or data?
                var startingNotchIndex = $handle.data("slider-default-position"),
                    notch = $this.find(".notch:eq(" + startingNotchIndex + ")");
                moveHandle(e, notch, startingNotchIndex, false);
            }

            function initNotchCallout() {
                var $notchTrigger = $this.find(".notchTrigger");
                $notchTrigger.each(function (i) {
                    var notch = $notchTrigger.eq(i);
                    notch.callout({
                        position: 'top',
                        align: 'center',
                        content: notch.data("callout"),
                        calloutClasses: 'sfsNotchCallout',
                        type: 'hover',
                        style: 'light',
                        onAfterOpen: function () {
                            renderCalloutCloseBindings($notchTrigger.eq(i));
                        }
                    });
                });
            }

            function renderHandleCallouts() {
                if (settings.useCallouts === true) {

                    //Set delay to allow callouts to initialize
                    setTimeout(function () {
                        initNotchCallout();
                    }, 10);

                    $handle.on({
                        'touchend mouseleave': function () {
                            var selectedNotch = $this.find(".notchTrigger").eq($handle.data("slider-notch-position"));
                            selectedNotch.callout("close");
                        },
                        'mouseenter mouseleave': function (e) {
                            var selectedNotch = $this.find(".notchTrigger").eq($handle.data("slider-notch-position"));
                            selectedNotch.trigger(e.type);
                        }
                    });
                }
            }

            function moveHandle(event, notch, notchIndex, animate) {
                var selectedNotch = $this.find(".notchTrigger").eq(notchIndex);
                $handle.data("slider-label", $(".notch").eq(notchIndex).data("callout"));
                $handle.data("slider-notch-position", notchIndex);
                $this.data("slider-notch-position", notchIndex);

                if (typeof jQuery.ui === "undefined") {
                    //Default to jquerys auto animation type
                    settings.handleAnimationType = "linear";
                }
                if (animate === true) {
                    $handle.animate({
                        left: notch.css("left")
                    }, {
                        duration: settings.handleAnimationTime,
                        easing: settings.handleAnimationType
                    });
                } else {
                    $handle.css("left", notch.css("left"));
                }

                if (event && event.type !== "resize" && selectedNotch) {
                    selectedNotch.callout("open");
                }

                return currentNotchIndex = notchIndex;
            }

            function setHandleColor() {
                var notchPosition = $handle.data("slider-notch-position");
                if (settings.startingNotch === notchPosition && $handle.hasClass("green")) {
                    $handle.removeClass("green").addClass("silver");
                } else if (settings.startingNotch !== notchPosition && $handle.hasClass("silver")) {
                    $handle.removeClass("silver").addClass("green");
                }
            }

            function renderHandleBinding() {
                //Slider drag
                $handle.on({
                    'touchstart mousedown': function (e) {
                        $(this).addClass("draggable");
                        $this.find(".track").show();
                    },
                });
            }

            function renderCalloutCloseBindings() {
                $(".sfsNotchCallout").on('mouseenter mouseleave', function () {
                    var $calloutEl = $(".sfsNotchCallout");
                    $calloutEl.hide();
                });
            }

            function addHoverClass() {
                var $track = $this.find(".track");
                if (!$track.hasClass("hover")) {
                    $track.addClass("hover");
                }
            }

            function addNotchClass() {
                var $notch = $this.find(".notch");
                if (!$notch.hasClass("hover")) {
                    $notch.addClass("hover");
                }
            }

            function renderSliderBindings() {
                //Slider drag
                renderHandleBinding();
                //Slider release
                $("body").on({
                    'touchend mouseup': function (e) {
                        setHandleColor();
                        $this.find(".notch").addClass("vHidden");
                        $handle.removeClass("draggable");
                        $handle.stop(true, true);
                        $this.find(".track").removeClass("hover");
                    },
                    'touchstart touchmove mousemove': function (e) {
                        if ($handle.hasClass("draggable")) {
                            var notchIndex = getNotchIndexForEvent(e);
                            if (currentNotchIndex !== notchIndex) {
                                var notch = $this.find(".notch:eq(" + notchIndex + ")");
                                moveHandle(e, notch, notchIndex, false);
                                if (settings.notchCount == 2) {
                                    renderHandleBinding();
                                }
                                addHoverClass();
                            }
                        }
                        if ($handle.hasClass("draggable")) {
                            $this.find(".track").show();
                            $this.find(".notch").removeClass("vHidden");
                        }
                    }
                });
                $this.on({
                    //Slider hover track
                    'mouseover': function () {
                        $this.find(".track").show();
                        addHoverClass();
                    },
                    'mouseenter': function () {
                        if ($handle.hasClass("silver")) {
                            $handle.removeClass("silver").addClass("green");
                        }
                        addHoverClass();

                    },
                    'mouseleave': function (e) {
                        if (!$handle.hasClass("draggable")) {
                            setHandleColor();
                            $this.find(".track").show();
                            $this.find(".notch").addClass("vHidden");
                            $this.find(".track").removeClass("hover");
                        };
                    },
                    //Slider hover node
                    'touchmove mousemove': function (e) {
                        var notchIndex = getNotchIndexForEvent(e),
                        selectedNotch = $this.find(".notchTrigger").eq(notchIndex);
                        var notch = $this.find(".notch:eq(" + notchIndex + ")");
                        //Convert string back to int hide all notches and show closest notch.
                        $this.find(".notch").addClass("vHidden");
                        addNotchClass();
                        addHoverClass();
                        notch.removeClass("vHidden");
                        selectedNotch.trigger("mouseenter");
                    },
                    'touchend click': function (e) {
                        var notchIndex = getNotchIndexForEvent(e);
                        var notch = $this.find(".notch:eq(" + notchIndex + ")");
                        addNotchClass();
                        moveHandle(e, notch, notchIndex, true);
                        setHandleColor();
                    }
                });
            }

            function roundNumber(number, points) {
                var decimals = "",
                    exponent = Math.pow(10, points),
                    num = Math.round((number * exponent)).toString();
                if (!points) {
                    return Math.round(number);
                }
                if (number === 0) {
                    for (var i = 0; i < points; i++) decimals += "0";
                    return "0." + decimals;
                }
                return num.slice(0, -1 * points) + "." + num.slice(-1 * points);
            }

            function getNotchIndexForEvent(e) {
                if (typeof e.originalEvent !== "undefined" && typeof e.originalEvent.touches !== "undefined") {
                    e = e.originalEvent.touches[0];
                }
                var pixelsBetweenNotches = ($this.width() / ((settings.notchCount) - 1));
                var cursorLeftOffsetFromSliderBar = e.clientX - $this.offset().left;
                var notchIndex = Math.round(cursorLeftOffsetFromSliderBar / pixelsBetweenNotches);
                if (notchIndex < 0) {
                    notchIndex = 0;
                } else if (notchIndex > settings.notchCount - 1) {
                    notchIndex = settings.notchCount - 1;
                }
                return notchIndex;
            }

            function setupEventHandlers() {
                $this.on("click touchend", function () {
                    settings.notchChange($this.data("slider-notch-position"));
                });
                $this.parents("body").bind("mousemove touchmove", function () {
                    if ($this.find(".handle").hasClass("draggable")) {
                        settings.notchChange($this.data("slider-notch-position"));
                    }
                });
            }

            initSettings();
            createTrack();
            createNotches();
            createTriggerNotchesForCallouts();
            createTrackCover();
            createHandle();
            initHandlePosition();
            renderSliderBindings();
            renderHandleCallouts();
            setupEventHandlers();
            $(window).resize(function (e) {
                initHandlePosition(e);
            });
        });
    };
}(jQuery));(function () {
    var sliderApp = angular.module('SliderApp', ['sliderWidgetModule', 'SearchFormServiceUI']);

    sliderApp.service('urlParsingService', ['$window', function ($window) {
        this.getQueryStringValue = function (key) {
            if (typeof (key) !== 'string') {
                return '';
            }

            // Some keys can have multiple representations in the url.  For example, it is acceptable for
            // LEC and FMC parameters to omit an index or use index 0.
            //
            // ex. "msydy" and "msydy0" both refer to the first "self any date year".
            //
            // the keys array is meant to contain all key representations.
            var keys = [key];
            var keyParts = this.getKeyPartsOrNull(key);
            if (keyParts) {
                // if there is no index, then add same key with an index of 0.
                if (keyParts.index == '')
                    keys.push(keyParts.prefix + '0' + keyParts.suffix);
                    // if the index is 0, then add the same key without the index on it.
                else if (keyParts.index == '0')
                    keys.push(keyParts.prefix + keyParts.suffix);
            }

            var keyValue = '';
            $.each(keys, function (keyIndex, keyToTry) {
                keyToTry = keyToTry.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
                var regexS = "[\\?&]" + keyToTry + "=([^&#]*)",
                    regex = new RegExp(regexS),
                    results = regex.exec($window.location.href);
                if (results) {
                    keyValue = decodeURIComponent(results[1].replace(/\+/g, " "));
                    return false;  // ends the jQuery foreach loop
                }
            });

            if (keyValue) {
                keyValue = $.trim(keyValue);
            }

            return keyValue;
        };
        this.getKeyPartsOrNull = function (key) {
            // match variable will match against LEC and FMC parameters and will return
            // null if the match fails or will return the following information (by index):
            //    0. Entire string
            //    1. Prefix (everything before index)
            //    2. Index or empty string
            //    3. Suffix (everything after index.  e.g. "_x", "__ftp", "-ftp", etc...)
            // ex.  "msbdy4_x" returns ["msbdy4_x", "msbdy", "4", "_x"]
            // ex.  "msbdy_x"  returns ["msbdy_x",  "msbdy",  "", "_x"]
            //
            // Regex broken down
            //
            //      ^                -- Start of string
            //      (ms[a-z]{3})     -- First capturing group (1. above).  Matches "ms" followed by any 3 alphabetic chars
            //      (\d{0,2})        -- Second capturing group (2. above).  Matches up to 2 digits
            //      ((?:_|-).*)?     -- Optional Third capturing group (3. above).  Matches an "_" or a "-" followed by anything
            //      $                -- End of string
            //
            var match = key.match(/^(ms[a-z]{3})(\d{0,2})((?:_|-).*)?$/);
            if (match) {
                var eventType = match[0].substr(2, 1);
                var indexAsInt = match[2] == '' ? 0 : parseInt(match[2]);
                return {
                    eventType: eventType,
                    inputName: match[0],
                    prefix: match[1],
                    index: match[2],
                    indexAsInt: indexAsInt,
                    suffix: match[3] || ''
                };
            }
            return null;
        };
        this.removeURLParameter = function (url, parameter) {
            if (!url) url = $window.location.href;
            var urlParts = getUrlParts(url);
            if (urlParts.queryString.length == 0 || urlParts.queryString == '?') return url;
            var queryParts = urlParts.queryString.substring(1).split('&');
            var encodedKey = encodeURIComponent(parameter);
            var prefix = encodedKey + '=';
            for (var i = 0; i < queryParts.length; ++i) {
                var queryPart = queryParts[i];
                if (queryPart == encodedKey || queryPart.substring(0, prefix.length) == prefix) {
                    queryParts.splice(i, 1);
                    --i;
                }
            }
            // end of uri is one of... 1.) where query string begins 2.) where fragment begins or 3.) end of string
            var newQueryStr = queryParts.length == 0 ? '' : '?' + queryParts.join('&');
            var newUrl = urlParts.uri + newQueryStr + urlParts.fragment;
            return newUrl;
        };
        this.updateQueryStringParameter = function (url, key, value) {
            // Ensure there is a url to work with
            if (!url) url = $window.location.href;

            // The following regular expression is used to find the query string key passed in and its value.  It will match the following groups
            // $0    - entire match.  e.g.  &someKey=someValue........
            // $1    - query string prefix.  e.g. ? or &
            // $2    - character immediately following query string key value pair
            // $3    - everything else after the character immediately following query string key value pair
            var re = new RegExp("([?]|&)" + escapeStrToUseInRegex(key) + "=.*?(&|#|$)(.*)", "gi");

            // If the key to update exists in the current url
            if (re.test(url)) {
                // If a new value was provided then update the key value pair
                if (typeof value !== 'undefined' && value !== null)
                    return url.replace(re, '$1' + key + "=" + value + '$2$3');
                return this.removeURLParameter(url, key);
            }

            // Key to update isn't in the url, so if a value was provided then add the new key / value
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                var hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }

            // Key to update isn't in the url and a null value was provided, so just do nothing and return the url
            return url;
        };
        function getUrlParts(url) {
            var queryIndex = url.indexOf('?');
            var fragmentIndex = url.indexOf('#');
            // end of uri is one of... 1.) where query string begins 2.) where fragment begins or 3.) end of string
            var uriEndIndex = queryIndex > 0 ? queryIndex : fragmentIndex > 0 ? fragmentIndex : url.length;
            var uri = url.substring(0, uriEndIndex);
            var fragmentStr = fragmentIndex < 0 ? '' : url.substring(fragmentIndex);
            var queryStr = queryIndex < 0 ? '' : url.substring(queryIndex, fragmentIndex < 0 ? url.length : fragmentIndex);
            return {
                uri: uri,
                queryString: queryStr,
                fragment: fragmentStr
            };
        };
        function escapeStrToUseInRegex(str) {
            return (str + '').replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        };
    }]);

    sliderApp.factory('sliderLocalizationService', ['$window', function ($window) {
        if (typeof $window.Ancestry == 'undefined') $window.Ancestry = {};
        if (typeof $window.Ancestry.SFS == 'undefined') $window.Ancestry.SFS = {};
        if (typeof $window.Ancestry.SFS.Strings == 'undefined') $window.Ancestry.SFS.Strings = {};
        return {
            get: function (key) {
                var str = $window.Ancestry.SFS.Strings[key];
                if (str) {
                    for (var i = 1; i < arguments.length; ++i) {
                        var arg = arguments[i];
                        str = str.replace("{" + (i - 1) + "}", arg);
                    }
                    return str;
                }
                // If key was not found, return null
                return null;
            }
        };
    }]);

    sliderApp.factory('collectionPriorityService', [function () {
        return function () {
            var options = Ancestry.SFS.CollectionSelectOptions;
            return options;
        };
    }]);

    //Result returned from the service
    sliderApp.controller('SliderController', ['$scope', 'sliderResultsFactory', 'nonSliderDataService', 'collectionPriorityService', 'sliderLocalizationService', '$window', 'urlParsingService', function ($scope, sliderResultsFactory, nonSliderDataService, collectionPriorityService, sliderLocalizationService, $window, urlParsingService) {
        $scope.ShouldDisableUpdateButton = function () {
            return $scope.Url == "";
        };
        $scope.SubmitSearch = function () {
            if (!$scope.ShouldDisableUpdateButton()) {
                $window.location.href = $scope.Url;
            }
        };
        //Slider data
        $scope.SliderResults = sliderResultsFactory.getProcessedSliderData();

        $scope.CollectionFocusOptionForPartner = $window.Ancestry.SFS.CollectionFocusOptionForPartner;

        $scope.CurrentCollectionOptionSelected = 0;

        $scope.Sbo = urlParsingService.getQueryStringValue("sbo");

        //Update Button HREF
        $scope.Url = "";

        var updateUrlToRemovePaging = function (currentUrl) {
            currentUrl = urlParsingService.removeURLParameter(currentUrl, "pgoff");
            currentUrl = urlParsingService.removeURLParameter(currentUrl, "fh");
            currentUrl = urlParsingService.removeURLParameter(currentUrl, "fsk");
            currentUrl = urlParsingService.removeURLParameter(currentUrl, "bsk");
            return currentUrl;
        };

        var getComparisonUrl = function (url) {
            //remove query parameters that aren't important for determining if a slider edit has been made
            url = urlParsingService.removeURLParameter(url, "msT");
            return url;
        };

        var updateUrlForTrackingParams = function (url) {
            //msT == "1" when the search has not been edited/refined, so we remove it when using sliders
            url = urlParsingService.removeURLParameter(url, "msT");
            return url;
        };

        $scope.UpdateUrlFromSliderData = function (item) {
            //Check values of event and location values to determine what additional params need to be set.InputExactName
            var key = item.InputExactName,
                value = item.InputExactValue,
                currentUrl = $scope.Url,
                msav = "MSAV",
                msadvCb = "MS_AdvCB",
                msavValue = urlParsingService.getQueryStringValue(msav);

            if (sliderResultsFactory.isLocationSlider(item)) {
                // If location slider has gpid exactness...
                if (urlParsingService.getQueryStringValue(item.InputGpid) !== "") {
                    if (value === '') {
                        currentUrl = urlParsingService.removeURLParameter(currentUrl, item.InputExactName);
                        currentUrl = urlParsingService.removeURLParameter(currentUrl, item.InputGpidExact);
                    } else {
                        currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, item.InputExactName, '1');
                        currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, item.InputGpidExact, value);
                    }
                } else { // location slider doesn't have gpid exactness so it's either exact or broad
                    currentUrl = value === ''
                        ? urlParsingService.removeURLParameter(currentUrl, item.InputExactName)
                        : urlParsingService.updateQueryStringParameter(currentUrl, item.InputExactName, value);
                }
            } else if (sliderResultsFactory.isDateSlider(item)) {
                if (value === '') {
                    currentUrl = urlParsingService.removeURLParameter(currentUrl, item.InputExactName);
                    currentUrl = urlParsingService.removeURLParameter(currentUrl, item.InputRange);
                } else {
                    currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, item.InputExactName, "1");
                    currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, item.InputRange, value);
                }
            } else {  // All other slider types...
                currentUrl = value === ''
                    ? urlParsingService.removeURLParameter(currentUrl, key)
                    : urlParsingService.updateQueryStringParameter(currentUrl, key, value);
            }

            // Ensure "Match All Terms" exactly params are removed / altered if new exactness value was set to broad
            if (value === '' || value === '0') {
                //Exact Checkbox MS_AdvCB=1 or not on query string and MSAV = -1, 1, 2, 0
                if (urlParsingService.getQueryStringValue(msadvCb) === "1") {
                    currentUrl = urlParsingService.removeURLParameter(currentUrl, msadvCb);
                }
                if (msavValue === "-1") {
                    currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, msav, "0");
                } else if (msavValue === "2") {
                    currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, msav, "1");
                }
            }

            currentUrl = updateUrlToRemovePaging(currentUrl);
            currentUrl = updateUrlForTrackingParams(currentUrl);

            //remove parameters sliders doesn't care about for updating purposes
            var currentCheckUrl = getComparisonUrl($window.location.href);
            var sliderCheckUrl = getComparisonUrl(currentUrl);
            if (sliderCheckUrl === currentCheckUrl) {
                currentUrl = "";
            }
            $scope.Url = currentUrl;
        };

        //Validating if there are issues with values in the form
        $scope.FormHasError = false;

        //Old Search Simulator Year Values
        $scope.OssModel = { yearStart: null, yearEnd: null };
        $scope.ShouldShowOssYearRange = false;
        $scope.SetOssModelFromOssParam = function () {
            $scope.OssModel.yearStart = urlParsingService.getQueryStringValue("ossyear");
            $scope.OssModel.yearEnd = urlParsingService.getQueryStringValue("ossyearend");
            //We bind ShouldShowOssYearRange instead of binding yearStart and yearEnd in the ng-show.
            //Otherwise if the user were to empty both inputs out the year range content would disappear
            if ($scope.OssModel.yearStart || $scope.OssModel.yearEnd) {
                $scope.ShouldShowOssYearRange = true;
            }
        };
        $scope.SetOssModelFromOssParam();

        $scope.UpdateUrlForOssYearRange = function (ossObj) {
            var ossYearStart = "ossyear",
                ossYearEnd = "ossyearend",
                currentUrl = $window.location.href;
            //Old Search Simulator
            if (ossObj.yearStart || ossObj.yearStart === "") {
                if (ossObj.yearStart === "") {
                    currentUrl = urlParsingService.removeURLParameter(currentUrl, ossYearStart);
                } else {
                    currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, ossYearStart, ossObj.yearStart);
                }
            }
            if (ossObj.yearEnd || ossObj.yearEnd === "") {
                if (ossObj.yearEnd === "") {
                    currentUrl = urlParsingService.removeURLParameter(currentUrl, ossYearEnd);
                } else {
                    currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, ossYearEnd, ossObj.yearEnd);
                }
            }
            if (currentUrl === $window.location.href) {
                currentUrl = "";
            }
            return $scope.Url = currentUrl;
        };

        //Collection Select
        $scope.CollectionSelectModel = { value: null };
        $scope.showCollectionPriority = nonSliderDataService.hasCollectionPriority();
        $scope.CollectionSelectOptions = collectionPriorityService();
        $scope.SetInitialOptionFromCollectionParam = function () {
            var i,
                useDefault = true;
            for (i = 0; i < $scope.CollectionSelectOptions.length; i++) {
                if (urlParsingService.getQueryStringValue("cp") === $scope.CollectionSelectOptions[i].value) {
                    $scope.CollectionSelectModel.value = $scope.CollectionSelectOptions[i].value;
                    useDefault = false;
                    break;
                }
            }
            if (useDefault) {
                $scope.CollectionSelectModel.value = $scope.CollectionFocusOptionForPartner.toString();
            }
            $scope.CurrentCollectionOptionSelected = $scope.CollectionSelectModel.value;
            return $scope.CollectionSelectModel.value;
        };
        $scope.UpdateUrlFromCollectionSelect = function () {
            var currentUrl = $scope.Url,
                sbo = "sbo",
                cp = "cp",
                cpxt = "cpxt";
            currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, cp, $scope.CollectionSelectModel.value);
            currentUrl = urlParsingService.updateQueryStringParameter(currentUrl, cpxt, "1");
            //If a change to the url needs to take place and the current url contains sbo = 0, remove sbo and add cpxt = 1 and cp = current selection.
            if (urlParsingService.getQueryStringValue(sbo) === "0") {
                currentUrl = urlParsingService.removeURLParameter(currentUrl, sbo);
            }
            currentUrl = updateUrlToRemovePaging(currentUrl);
            if (currentUrl === $window.location.href) {
                currentUrl = "";
            }
            $scope.Url = currentUrl;
        };
        $scope.SetInitialOptionFromCollectionParam();

        // ****************************************************
        //   More Search Fields (Appears Below Sliders)
        // ****************************************************
        $scope.moreSearchFields = nonSliderDataService.getMoreSearchFieldsData();
        $scope.moreSearchFieldsText = sliderLocalizationService.get("moreSearchFields", $scope.moreSearchFields.TotalMemberCount);
        // Expand "More Info" area for manual searches, and collapse for tree searches
        $scope.moreSearchFieldsExpanded = !urlParsingService.getQueryStringValue('ssrc');
        $scope.toggleMoreSearchFieldsExpansion = function () {
            $scope.moreSearchFieldsExpanded = !$scope.moreSearchFieldsExpanded;
        };
    }]);  // End SlidersController
})();angular.module('SliderApp').directive('ossYear', [function () {
    return {
        link: function (scope) {
            $("#ossForm input").on("blur", function () {
                var $this = $(this),
                    $alert = $("#ossForm").find(".alert");
                if (scope.FormHasError) {
                    $this.parents("form").find("input").addClass("error");
                    $alert.alert("open");
                } else {
                    $this.parents("form").find("input").removeClass("error");
                    $alert.alert("close");
                }
            });
            $("#ossForm input").on("keyup", function () {
                var $this = $(this),
                    $alert = $("#ossForm").find(".alert"),
                    yearStart = parseInt(scope.OssModel.yearStart, 10),
                    yearEnd = parseInt(scope.OssModel.yearEnd, 10);
                scope.$apply(function() {                
                    if (yearStart > yearEnd) {
                            scope.FormHasError = true;
                    } else {
                            scope.FormHasError = false;
                    }
                });
                scope.$apply(function () {
                    if (!scope.FormHasError) {
                        scope.UpdateUrlForOssYearRange(scope.OssModel);
                        $this.parents("form").find("input").removeClass("error");
                        $alert.alert("close");
                    } else {
                        scope.Url = "";
                    }
                });
            });
        }
    };
}]);
angular.module('SliderApp').directive('collectionSelectDirective', ['urlParsingService', function (urlParsingService) {
    return {
        link: function (scope, element, attrs) {
            var selectChanged = false,
                option = "";
            scope.$watch(attrs.ngModel, function () {
                var cpParam = urlParsingService.getQueryStringValue("cp");
                option = scope.$eval(attrs.ngModel);
                if (option !== cpParam) {
                    selectChanged = true;
                } else {
                    selectChanged = false;
                }
                if (selectChanged) {
                    $("#refineView .updateFilters").removeAttr("href");
                }
            });
        }
    };
}]);angular.module('SliderApp').service("configValues", ['$window', function ($window) {
    return {
        getMaxSliderCount: function () {
            return ($window.Ancestry && $window.Ancestry.SFS && $window.Ancestry.SFS.MaxSliders) ? $window.Ancestry.SFS.MaxSliders : 10;
        }
    };
}]);
angular.module('SliderApp').factory('sliderResultsFactory', ['urlParsingService', 'sliderLocalizationService', 'nonSliderDataService', 'sfsLocationExactnessProvider', 'configValues', 
    function (urlParsingService, localizationService, nonSliderDataService, sfsLocationExactnessProvider, configValues) {

    var exactX = "_x";
    var pInfo = "_PInfo";
    var SlidersToDefaultWhenHasInvalidExactness = ['gsfn', 'gsln', 'msbdy', 'msbdy0', 'msbpn__ftp', 'msbpn0__ftp', 'msddy', 'msddy0', 'msdpn__ftp', 'msdpn0__ftp'];
    var domPrefix = 'sfs_';
    var locationExactnessMap = {
        "broad": { value: "",    alternateValues: ["0"],  label: localizationService.get("BroadSearchFilterLabel") },
        "PC":    { value: "PC",                           label: localizationService.get("CountryOptionText") },
        "PAS":   { value: "PAS",                          label: localizationService.get("StateAndAdjacentStatesOptionText") },
        "PS":    { value: "PS",                           label: localizationService.get("StateOptionText") },
        "PACO":  { value: "PACO",                         label: localizationService.get("CountyAndAdjacentCountiesOptionText") },
        "PCO":   { value: "PCO",                          label: localizationService.get("CountyOptionText") },
        "exact": { value: "1",   alternateValues: ["XO"], label: localizationService.get("ExactLabel") },
        "1":     { value: "1",   alternateValues: ["XO"], label: localizationService.get("ExactLabel") }
    }

    function getProcessedSliderData() {
        var sliders = getAllSlidersWithValuesOnUrl();
        var filteredSliders = getFilteredSliders(sliders);
        updateNonSliderDataServiceMetadataToExcludeValuesShownInSliders(filteredSliders);
        return filteredSliders;
    };

    function getAllSlidersWithValuesOnUrl() {
        var slidersMetadata = getSlidersMetadata();  // collection describing how to find slider data and organize it
        var sliders = [];  // Collection of all sliders found that have values on the url
        // Traverse all metadata objects to create slider configurations where a value for that type of slider exists
        for (var i = 0; i < slidersMetadata.length; i++) {
            var metadata = slidersMetadata[i];
            var slider;
            // Some metadata objects are templates that describe how to find multiple sliders for a partiular type so that you can
            // end up with sliders for "msrdy", "msrdy1", "msrdy2", etc...
            // e.g. Residence Event can have up to 11 entries, so there are potentially 11 sliders that could be created but they
            //      all are described the same way.
            if (metadata.MaxCount) {
                for (var queryIndex = 0; queryIndex < metadata.MaxCount; ++queryIndex) {
                    var indexStr = queryIndex == 0 ? '' : '' + queryIndex;
                    slider = {
                        InputName: metadata.InputNameFormat.replace("{0}", indexStr),
                        InputPrefix: metadata.InputPrefix,
                        NotchArray: metadata.NotchArray.slice(0)
                    };
                    if (metadata.InputRangeFormat) {
                        slider.InputRange = metadata.InputRangeFormat.replace("{0}", indexStr);
                    } else {
                        slider.InputPrefix = metadata.InputPrefix;
                        slider.InputGpid = metadata.InputGpidFormat.replace("{0}", indexStr);
                    }
                    slider = getSliderConfigurationWithUrlDataOrNull(slider);
                    if (slider != null) {
                        sliders.push(slider);
                    }
                }
            }
                // metadata object directly describes a single slider that may have a value on the url
            else {
                slider = getSliderConfigurationWithUrlDataOrNull($.extend({}, metadata));
                if (slider != null) {
                    sliders.push(slider);
                }
            }
        }
        return sliders;
    }

    function getSliderConfigurationWithUrlDataOrNull(slider) {
        if (slider == null) return null;
        var sliderLabel = urlParsingService.getQueryStringValue(slider.InputName);
        if (sliderLabel !== "") {
            slider.InputLabel = sliderLabel;
            slider.InputExactName = slider.InputName + exactX;

            if (isDateSlider(slider)) {
                slider.NotchArray[0].name = slider.InputName + exactX;
                slider.NotchArray[slider.NotchArray.length - 1].name = slider.InputName + exactX;
            }

            if (isLocationSlider(slider)) {
                slider.InputGpidExact = slider.InputGpid + exactX;
                slider.InputPInfo = slider.InputGpid + pInfo;
                initializeNotchesForLocationEventSliders(slider);
            }

            //Get notchArray values and compare it to the query string. Set the index number of the notchArray.
            setNotchFromQueryString(slider);
            // If the StartingNotchNumber is unknown, then we do not know how to represent this slider, so
            // do not show this slider (it should appear in the "Show More Search Fields" area).
            if (typeof (slider.StartingNotchNumber) == 'undefined') {
                if ($.inArray(slider.InputName,SlidersToDefaultWhenHasInvalidExactness) == -1)
                    return null;
                slider.StartingNotchNumber = 0;
            }

            slider.InputExactValue = slider.NotchArray[slider.StartingNotchNumber].value;
            return slider;
        }
        return null;
    }

    function getFilteredSliders(sliders) {
        var filteredSliders = [];               // All sliders to be shown in sorted order
        var optionalSliders = sliders.slice(0); // Collection of optional sliders

        // Remove important sliders from the optional Sliders collection.  Most of these can immediately go in the filteredSliders Array.
        function removeSliderWithInputNameFromOptionalSlidersArray(inputName, addToFilteredArray) {
            var sliderFindResult = findSliderWithInputName(inputName, optionalSliders);
            if (sliderFindResult != null) {
                if (addToFilteredArray) {
                    filteredSliders.push(sliderFindResult.slider);
                }
                optionalSliders.splice(sliderFindResult.index, 1);
            }
            return sliderFindResult != null ? sliderFindResult.slider : null;
        };
        removeSliderWithInputNameFromOptionalSlidersArray('gsfn', true);
        removeSliderWithInputNameFromOptionalSlidersArray('gsln', true);
        removeSliderWithInputNameFromOptionalSlidersArray('msbdy', true) || removeSliderWithInputNameFromOptionalSlidersArray('msbdy0', true);
        removeSliderWithInputNameFromOptionalSlidersArray('msbpn__ftp', true) || removeSliderWithInputNameFromOptionalSlidersArray('msbpn0__ftp', true);
        var group1Length = filteredSliders.length;
        var deathSliderDate = removeSliderWithInputNameFromOptionalSlidersArray('msddy', false) || removeSliderWithInputNameFromOptionalSlidersArray('msddy0', false);
        var deathSliderLocation = removeSliderWithInputNameFromOptionalSlidersArray('msdpn__ftp', false) || removeSliderWithInputNameFromOptionalSlidersArray('msdpn0__ftp', false);

        // Sort Optional Sliders by Date.  See Sort Rules
        var eventTypeSortOrder = ["b", "g", "m", "r", "a", "e", "i", "y", "w", "d"];
        optionalSliders.sort(function (slider1, slider2) {
            /**
            * Sort Rules
            *      1.) Sliders with dates are before sliders that do not have dates
            *      2.) Sliders with dates are sorted chronologically lowest to highest (most recent)
            *      3.) Sliders without dates will have their order maintained relative to where they are to each other
            **/
            var date1 = parseInt(urlParsingService.getQueryStringValue(slider1.InputName));
            var date2 = parseInt(urlParsingService.getQueryStringValue(slider2.InputName));
            var isSlider1Date = slider1.InputRange && !isNaN(date1);
            var isSlider2Date = slider2.InputRange && !isNaN(date2);
            if (isSlider1Date && !isSlider2Date) return -1;
            if (isSlider2Date && !isSlider1Date) return 1;
            if (!isSlider1Date && !isSlider2Date) {
                // Put non-location sliders below location sliders (towards the back of the array).
                var isSlider1Location = typeof slider1.InputGpid != "undefined";
                var isSlider2Location = typeof slider2.InputGpid != "undefined";
                if (isSlider1Location && !isSlider2Location) return -1;
                if (!isSlider1Location && isSlider2Location) return 1;
                if (!isSlider1Location && !isSlider2Location) return 0;
                // Group and sort location sliders by event type.
                var slider1KeyParts = urlParsingService.getKeyPartsOrNull(slider1.InputName);
                var slider2KeyParts = urlParsingService.getKeyPartsOrNull(slider2.InputName);
                var slider1EventTypeIndex = $.inArray(slider1KeyParts.eventType, eventTypeSortOrder);
                var slider2EventTypeIndex = $.inArray(slider2KeyParts.eventType, eventTypeSortOrder);
                if (slider1EventTypeIndex < slider2EventTypeIndex) return -1;
                if (slider1EventTypeIndex > slider2EventTypeIndex) return 1;
                // Sort sliders within event type groups by index. e.g. msrpn1 appears before msrpn2
                if (slider1KeyParts.indexAsInt < slider2KeyParts.indexAsInt) return -1;
                if (slider1KeyParts.indexAsInt > slider2KeyParts.indexAsInt) return 1;
                return 0;
            }
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
            return 0;
        });

        // Put all sliders together in filteredSliders array
        filteredSliders = filteredSliders.concat(optionalSliders);
        if (deathSliderDate != null) filteredSliders.push(deathSliderDate);
        if (deathSliderLocation != null) filteredSliders.push(deathSliderLocation);

        // Find location sliders that have an associated date slider.  Move these together and mark the location
        // slider as nested and update the label.
        for (var i = filteredSliders.length - 1; i >= 0; --i) {
            var slider = filteredSliders[i];
            var locationMatch = slider.InputName.match(/^ms([a-z])pn(\d{0,2})__ftp$/);
            if (locationMatch) {
                var relatedDateSliderInputName = "ms" + locationMatch[1] + "dy" + locationMatch[2];
                var dateSliderFindResult = findSliderWithInputName(relatedDateSliderInputName, filteredSliders);
                if (dateSliderFindResult != null) {
                    slider.IsNested = true;
                    slider.InputPrefix = localizationService.get("InLabelSliderPrefix") + ": ";
                    var newIndex = dateSliderFindResult.index + 1;
                    var oldIndex = i;
                    if (newIndex < oldIndex) {
                        // remove slider to move
                        filteredSliders.splice(oldIndex, 1);
                        // insert slider into new position
                        filteredSliders.splice(newIndex, 0, slider);
                        ++i;
                    }
                }
            }
        }

        // For Tree Searches, limit the number of sliders that are shown
        if (urlParsingService.getQueryStringValue("ssrc")) {
            var slidersToRemoveCount = Math.max(filteredSliders.length - configValues.getMaxSliderCount(), 0);

            var arr1 = filteredSliders.slice(0, group1Length);
            var arr2 = filteredSliders.slice(group1Length, group1Length + optionalSliders.length);
            var arr3 = filteredSliders.slice(group1Length + optionalSliders.length);

            var slidersRemovedCount = limitSlidersArray(arr2, slidersToRemoveCount);
            filteredSliders = arr1.concat(arr2).concat(arr3);
            limitSlidersArray(filteredSliders, slidersToRemoveCount - slidersRemovedCount);
        }

        return filteredSliders;
    };

    function limitSlidersArray(sliders, limit) {
        var slidersToRemoveCount = Math.min(sliders.length, limit);
        if (slidersToRemoveCount <= 0 || sliders.length == 0) return 0;
        var startRemoveIndex = sliders.length - slidersToRemoveCount;
        var firstSliderToRemove = sliders[startRemoveIndex];
        if (firstSliderToRemove.IsNested) {
            startRemoveIndex--;
            slidersToRemoveCount++;
        }

        sliders.splice(startRemoveIndex, slidersToRemoveCount);
        return slidersToRemoveCount;
    };

    function findSliderWithInputName(inputName, sliders) {
        for (var i = 0; i < sliders.length; ++i) {
            if (sliders[i].InputName === inputName) {
                return {
                    slider: sliders[i],
                    index: i
                };
            }
        }
        return null;
    };

    function existsInStringArrayCaseInsensitive(array, value) {
        if (!array || array.length === 0) {
            return false;
        }

        if (value == null) {
            return false;
        }

        var valueLowerCase = value.toLowerCase();
        for (var i = 0; i < array.length; i++) {
            if (array[i].toLowerCase() === valueLowerCase) {
                return true;
            }
        }
        return false;
    };

    function setNotchFromQueryString(sliderConfig) {
        // Handle case where date slider has exact specified but with no proximity information.  The ideal way to assign a slider notch for dates
        // is based off the proximity value.  When this value is missing, only the exactness parameter can indicate if it should be broad or exact.
        if (isDateSlider(sliderConfig)) {
            var dateExactValue = urlParsingService.getQueryStringValue(sliderConfig.InputExactName);
            var isDateExact = dateExactValue === '1' || dateExactValue === 'XO';
            var isDateSliderWithExactSearchAndNoProximity = isDateExact && urlParsingService.getQueryStringValue(sliderConfig.InputRange) === "";
            if (isDateSliderWithExactSearchAndNoProximity) {
                // Assign slider position to the most exact position possible (should only have the "Broad" and "Exact" notches
                sliderConfig.StartingNotchNumber = sliderConfig.NotchArray.length - 1;
                return;
            }
        }
        // A location slider with gpid info and no exactness information is invalid, so do not assign a slider position as we can't represent the possible
        // notches with accuracy.
        else if (isLocationSlider(sliderConfig)) {
            var gpid = urlParsingService.getQueryStringValue(sliderConfig.InputGpid);
            if (gpid !== '' && 
                sfsLocationExactnessProvider.getExactnesses(domPrefix, gpid).length === 0 &&
                urlParsingService.getQueryStringValue(sliderConfig.InputPInfo) === '') {
                // return without assigning a slider position which will result in the slider not being shown
                return;
            }
        }

        // Get NotchArray values and compare it to the query string. Set the starting index number of the notchArray.
        for (var notchIndex = 0; notchIndex < sliderConfig.NotchArray.length; notchIndex++) {
            // Has Gpid or Range
            if (doesUrlValueIndicateThisNotchPositionShouldBeUsed(sliderConfig, notchIndex)) {
                sliderConfig.StartingNotchNumber = notchIndex;
                break;
            }
        }
    };

    function doesUrlValueIndicateThisNotchPositionShouldBeUsed(sliderConfig, n) {
        // Start by checking InputRange and InputGpidExact as methods of matching.
        var valuesForNotchPosition = [sliderConfig.NotchArray[n].value];
        if (sliderConfig.NotchArray[n].alternateValues) {
            valuesForNotchPosition = valuesForNotchPosition.concat(sliderConfig.NotchArray[n].alternateValues);
        }

        var inputExactnessValue;
        if (isDateSlider(sliderConfig)) {
            inputExactnessValue = urlParsingService.getQueryStringValue(sliderConfig.InputRange);
        }
        else if (isLocationSlider(sliderConfig)) {
            inputExactnessValue = urlParsingService.getQueryStringValue(sliderConfig.InputGpid) != ''
                ? urlParsingService.getQueryStringValue(sliderConfig.InputGpidExact)
                : urlParsingService.getQueryStringValue(sliderConfig.InputExactName);
        }
        else {
            // case for first name / last name slider
            inputExactnessValue = urlParsingService.getQueryStringValue(sliderConfig.InputExactName);
        }
        return existsInStringArrayCaseInsensitive(valuesForNotchPosition, inputExactnessValue);
    };

    function isDateSlider(slider) {
        return typeof slider.InputRange != 'undefined';
    };

    function isLocationSlider(slider) {
        return typeof slider.InputGpid != 'undefined';
    };

    function removeItemsFromNotchArrayForGpid(notchArray, item) {
        var idx = -1;
        for (var i = 0; i < notchArray.length; i++) {
            if (notchArray[i].value === item) {
                idx = i;
                break;
            }
        }
        if (idx >= 0) {
            notchArray.splice(idx, 1);
        }
    };

    function initializeNotchesForLocationEventSliders(sliderConfig) {
        // If this slider configuration is not a Location Event type, then skip further processing
        if (!isLocationSlider(sliderConfig)) return;

        var pInfoValue = urlParsingService.getQueryStringValue(sliderConfig.InputPInfo);
        var gpid = urlParsingService.getQueryStringValue(sliderConfig.InputGpid);
        var exactnesses = sfsLocationExactnessProvider.getExactnesses(domPrefix, gpid);
        sliderConfig.NotchArray = [];
        if (exactnesses.length === 0 && pInfoValue === '') {
            sliderConfig.NotchArray.push($.extend({}, locationExactnessMap["broad"]));
            sliderConfig.NotchArray.push($.extend({}, locationExactnessMap["exact"]));
        } else if (exactnesses.length > 0) {
            sliderConfig.NotchArray.push($.extend({}, locationExactnessMap["broad"]));
            for (var i = exactnesses.length - 1; i >= 0; --i) {
                var exactness = exactnesses[i];
                if (locationExactnessMap[exactness.acronym]) {
                    sliderConfig.NotchArray.push($.extend({}, locationExactnessMap[exactness.acronym]));
                }
            }
            // Last slider notch should always be the "Exact" slider notch, but it should also be configured to match against targeted query 
            // strings for that esactness.  e.g. A state gpid for "Texas, USA" with an exactness of "PS" (state level exactness) should show
            // the slider at the "Exact" notch since state is the most exact position for that gpid.
            var lastNotch = sliderConfig.NotchArray.splice(sliderConfig.NotchArray.length - 1, 1)[0]; // remove last notch
            var exactNotch = $.extend({}, locationExactnessMap["exact"]); // copy the exact notch
            exactNotch.alternateValues = lastNotch.alternateValues || []; // add the last notch value like "PS" as an alternative value for the "exact" notch
            exactNotch.alternateValues.push(lastNotch.value);
            sliderConfig.NotchArray.push(exactNotch); // add the exact notch
        } else {
            sliderConfig.NotchArray = [
                $.extend({}, locationExactnessMap["broad"]),
                $.extend({}, locationExactnessMap["PC"]),
                $.extend({}, locationExactnessMap["PAS"]),
                $.extend({}, locationExactnessMap["PS"]),
                $.extend({}, locationExactnessMap["PACO"]),
                $.extend({}, locationExactnessMap["PCO"]),
                $.extend({}, locationExactnessMap["exact"])
            ];

            //Figure out pipe length and number of notches.
            var levelId = parseInt(pInfoValue.split("|")[0].replace("-", ""));

            // Need to ask about why some locations will submit a levelId of 8, even though "State" specificity was selected.
            // E.g. "Unit Muchang, Dong Ujimqin Qi, Nei Mongol (Inner Mongolia), China"
            var exactNotchAlternateValues = sliderConfig.NotchArray[sliderConfig.NotchArray.length - 1].alternateValues;
            switch (levelId) {
                case 9: //Township
                case 8: //City
                    //Leave all exactness settings in for township
                    break;
                case 7: //County
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PCO"); //Removing PCO
                    exactNotchAlternateValues.push("PCO");
                    break;
                case 6: //County Region
                case 5: //State
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PS");   //Removing PS
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PACO"); //Removing PACO
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PCO");  //Removing PCO
                    exactNotchAlternateValues.push("PS");
                    break;
                case 4: //State Region (like "Southwestern States", "New England States")
                case 3: //Country
                case 2: //Country Region (like "United Kingdom")
                case 1: //Continent
                case 0: //Earth
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PACO"); //Removing PACO
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PCO");  //Removing PCO
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PS");   //Removing PS
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PAS");  //Removing PAS
                    removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PC");   //Removing PC
                    exactNotchAlternateValues.push("PC");
                    break;
            }

            if (levelId >= 7 &&
                pInfoValue.indexOf("|5027|") !== -1 || // Australia
                pInfoValue.indexOf("|3243|") !== -1) { // Canada
                //Remove PCO and PACO (county/adjacent counties)
                removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PACO"); //Removing PACO and PCO
                removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PCO");  //Removing PACO and PCO
            }

            if (levelId >= 5 && pInfoValue.indexOf("|3257|") !== -1 && (pInfoValue.indexOf("|5250|") !== -1 || // Wales
                pInfoValue.indexOf("|3251|") !== -1) || // England
                pInfoValue.indexOf("|3250|") !== -1) {  // Ireland
                //Remove PAS and PS (state/adjacent states)
                removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PAS"); //Removing PAS
                removeItemsFromNotchArrayForGpid(sliderConfig.NotchArray, "PS");  //Removing PS
            }
        }
    };

    function updateNonSliderDataServiceMetadataToExcludeValuesShownInSliders(sliders) {
        for (var i = 0; i < sliders.length; ++i) {
            var slider = sliders[i];
            nonSliderDataService.removeMoreSearchFieldByInputName(slider.InputName);
        }
    };

    var slidersMetadataStore = null;
    function getSlidersMetadata() {
        if (slidersMetadataStore) return slidersMetadataStore;
        slidersMetadataStore = [
            //Filter response object
            {
                InputName: "gsfn", /* Given name */
                NotchArray: [
                    { value: "0", label: localizationService.get("BroadSearchFilterLabel") },
                    { value: "NP_NN_NIC", alternateValues: ["NP_NIC", "NN_NIC", "NIC"], label: localizationService.get("ExactSimilarSoundsLikeInitialsSliderFilterText") },
                    { value: "NP_NN", alternateValues: ["NP"], label: localizationService.get("ExactSoundsLikeSimilarSliderFilterText") },
                    { value: "NN", label: localizationService.get("ExactSimilarSliderFilterText") },
                    { value: "1", alternateValues: ["XO"], label: localizationService.get("ExactLabel") }
                ]
            },
            {
                InputName: "gsln", /* Surname */
                NotchArray: [
                    { value: "NS_NP_NN", alternateValues: ["NS_NP", "NS_NN", "NS"], label: localizationService.get("BroadSearchFilterLabel") },
                    { value: "NP_NN", alternateValues: ["", "0", "NP"], label: localizationService.get("ExactSoundsLikeSimilarSliderFilterText") },
                    { value: "NN", label: localizationService.get("ExactSimilarSliderFilterText") },
                    { value: "1", alternateValues: ["XO"], label: localizationService.get("ExactLabel") }
                ]
            },
            {
                InputName: "msbdy", /* Birth Date Year Event */
                InputPrefix: localizationService.get("BornSliderPrefixLabel") + ": ",
                InputRange: "msbdp"
            },
            {
                InputName: "msbpn__ftp", /* Birth Place Name */
                InputPrefix: localizationService.get("BornSliderPrefixLabel") + ": ",
                InputGpid: "msbpn"
            },
            {
                InputName: "msgdy", /* Marriage Date Year Event */
                InputPrefix: localizationService.get("SliderMarriageLabel") + ": ",
                InputRange: "msgdp"
            },
            {
                InputName: "msgpn__ftp", /* Marriage Place Name */
                InputPrefix: localizationService.get("SliderMarriageLabel") + ": ",
                InputGpid: "msgpn"
            },
            {
                InputName: "msmdy", /* Marriage Date Year Event */
                InputPrefix: localizationService.get("SliderMarriageLabel") + ": ",
                InputRange: "msmdp"
            },
            {
                InputName: "msmpn__ftp", /* Marriage Place Name */
                InputPrefix: localizationService.get("SliderMarriageLabel") + ": ",
                InputGpid: "msmpn"
            },
            {
                InputNameFormat: "msrpn{0}__ftp", /* Residence Place Name */
                InputPrefix: localizationService.get("ResidenceEventLabel") + ": ",
                InputGpidFormat: "msrpn{0}",
                MaxCount: 11
            },
            {
                InputNameFormat: "msrdy{0}", /* Residence Event Date Year */
                InputPrefix: localizationService.get("ResidenceEventLabel") + ": ",
                InputRangeFormat: "msrdp{0}",
                MaxCount: 11
            },
            {
                InputName: "msady", /* Arrival Date Year Event */
                InputPrefix: localizationService.get("ArrivalEventLabel") + ": ",
                InputRange: "msadp"
            },
            {
                InputName: "msapn__ftp", /* Arrival Place Name */
                InputPrefix: localizationService.get("ArrivalEventLabel") + ": ",
                InputGpid: "msapn"
            },
            {
                InputName: "msedy", /* Departure Date Year Event */
                InputPrefix: localizationService.get("DepartureEventLabel") + ": ",
                InputRange: "msedp"
            },
            {
                InputName: "msepn__ftp", /* Departure Place Name */
                InputPrefix: localizationService.get("DepartureEventLabel") + ": ",
                InputGpid: "msepn"
            },
            {
                InputName: "msidy", /* Military Date Year Event */
                InputPrefix: localizationService.get("MilitaryEventLabel") + ": ",
                InputRange: "msidp"
            },
            {
                InputName: "msipn__ftp", /* Military Place Name */
                InputPrefix: localizationService.get("MilitaryEventLabel") + ": ",
                InputGpid: "msipn"
            },
            {
                InputNameFormat: "msydy{0}", /* Any Event Date Year */
                InputPrefix: localizationService.get("AnyLabelSliderPrefix") + ": ",
                InputRangeFormat: "msydp{0}",
                MaxCount: 11
            },
            {
                InputNameFormat: "msypn{0}__ftp", /* Any Place Name */
                InputPrefix: localizationService.get("AnyLabelSliderPrefix") + ": ",
                InputGpidFormat: "msypn{0}",
                MaxCount: 11
            },
            {
                InputNameFormat: "mswpn{0}__ftp", /* Any Place Name */
                InputPrefix: localizationService.get("AnyLabelSliderPrefix") + ": ",
                InputGpidFormat: "mswpn{0}",
                MaxCount: 11
            },
            {
                InputName: "msddy", /* Death Event Date Year */
                InputPrefix: localizationService.get("DeathEventLabel") + ": ",
                InputRange: "msddp"
            },
            {
                InputName: "msdpn__ftp", /* Death Place Name */
                InputPrefix: localizationService.get("DeathEventLabel") + ": ",
                InputGpid: "msdpn"
            }
        ];

        // Auto Populate metadata fields
        for (var i = 0; i < slidersMetadataStore.length; ++i) {
            var sliderMetadata = slidersMetadataStore[i];

            // Auto Populate Event Location GPID and No GPID Notch arrays
            if (sliderMetadata.InputGpid || sliderMetadata.InputGpidFormat) {
                sliderMetadata.NotchArray = [];
            }
                // Auto Populate Date Exactness (Proximity) Notch array
            else if (sliderMetadata.InputRange || sliderMetadata.InputRangeFormat) {
                sliderMetadata.NotchArray = [
                    { value: "", label: localizationService.get("BroadSearchFilterLabel") },
                    { value: "10", label: "+/- 10 " + localizationService.get("YearSliderFilterText") },
                    { value: "5", label: "+/- 5 " + localizationService.get("YearSliderFilterText") },
                    { value: "2", label: "+/- 2 " + localizationService.get("YearSliderFilterText") },
                    { value: "1", label: "+/- 1 " + localizationService.get("YearSliderFilterText") },
                    { value: "_x", label: localizationService.get("ExactLabel") }
                ];
            }
        }

        return slidersMetadataStore;
    };

    return {
        getProcessedSliderData: getProcessedSliderData,
        isDateSlider: isDateSlider,
        isLocationSlider: isLocationSlider
    };
}]);angular.module('SliderApp').service('nonSliderDataService', ['urlParsingService', 'sliderLocalizationService', function(urlParsingService, localizationService) {
    var ftp = "__ftp";

    function hasCollectionPriority() {
        var gl = urlParsingService.getQueryStringValue('gl');
        var cp = urlParsingService.getQueryStringValue('cp');
        var db = urlParsingService.getQueryStringValue('db');
        var showCollections = false;
        if (gl && (gl === 'ROOT_CATEGORY' || gl === 'allgs')) {
            showCollections = true;
        } else if (db) {
            // never show collection focus for database searches
        }
        else if (gl && !isNaN(gl)) {
            // If gl is a number, it is likely a category search which allows collection focus
            showCollections = true;
        } else if (cp) {
            // Show collection focus if it is on the query string and this is not a database search
            showCollections = true;
        } else if (!gl && !db) {
            // When we don't know what kind of search is going on, then show the collection focus (assume global search)
            showCollections = true;
        }
        return showCollections;
    };

    function getMoreSearchFieldsData() {
        var labelGroupsMetadata = getMoreSearchFieldsMetaData();
        var labelGroups = [];
        for (var labelIndex = 0; labelIndex < labelGroupsMetadata.length; labelIndex++) {
            // labelGroupMetadata is a grouping of search term information.  These range from simple like "Marriage"
            // to complex like "Family".  Marriage would be a label with at most one value where Family is a
            // grouping of "Father", "Mother", "Spouse", "Siblings", and "Children".
            var labelGroupMetadata = labelGroupsMetadata[labelIndex];
            var labelGroup = {
                Label: labelGroupMetadata.InputLabelPrefix,
                Summary: [],
                MemberCount: 0
            };
            if (labelGroupMetadata.SubGroup) {
                for (var searchTypeIndex = 0; searchTypeIndex < labelGroupMetadata.SubGroup.length; searchTypeIndex++) {
                    // searchType describes the type of search term like "Sibling", "Spouse", "Lived In", etc..
                    var searchType = labelGroupMetadata.SubGroup[searchTypeIndex];
                    for (var i = searchType.StartIndex; i < searchType.MaxCount; i++) {
                        var summaryLine = '';
                        // Add summary for Family Member
                        if (hasFirstOrLastName(searchType)) {
                            if ($.inArray(searchType.InputFirstName + i, searchType.ExcludeList) == -1) {
                                summaryLine += urlParsingService.getQueryStringValue(searchType.InputFirstName + i) + " ";
                            }
                            if ($.inArray(searchType.InputLastName + i, searchType.ExcludeList) == -1) {
                                summaryLine += urlParsingService.getQueryStringValue(searchType.InputLastName + i);
                            }
                        }
                        // Add summary for everything else
                        else if (hasInputNameOrLocation(searchType)) {
                            if ($.inArray(searchType.InputName + i, searchType.ExcludeList) == -1) {
                                summaryLine += urlParsingService.getQueryStringValue(searchType.InputName + i) + " ";
                            }
                            if ($.inArray(searchType.InputGpid + i, searchType.ExcludeList) == -1) {
                                summaryLine += urlParsingService.getQueryStringValue(searchType.InputGpid + i + ftp);
                            }
                        }
                        summaryLine = $.trim(summaryLine);

                        if (summaryLine) {
                            labelGroup.Summary.push(summaryLine);
                            labelGroup.MemberCount++;
                        }
                    }
                }
            }
            // Handle single entry group info.  e.g. Gender group has at most one value only
            else {
                var summary = urlParsingService.getQueryStringValue(labelGroupMetadata.InputName);

                // If this is the Gender group, then translate the 'f' and 'm' values to the "Male" and "Female" strings.
                if (summary && labelGroupMetadata.Male && labelGroupMetadata.Female) {
                    if (summary === 'f' || summary === 'F') {
                        summary = labelGroupMetadata.Male;
                    } else if (summary === 'm' || summary === 'M') {
                        summary = labelGroupMetadata.Female;
                    } else {
                        summary = '';  // ignore unknown gender value
                    }
                }

                // For Event types, grab the location text too
                if (labelGroupMetadata.InputPlaceName) {
                    summary += ' ' + urlParsingService.getQueryStringValue(labelGroupMetadata.InputPlaceName);
                }

                summary = $.trim(summary);
                if (summary != '') {
                    labelGroup.Summary.push(summary);
                    labelGroup.MemberCount = 1;
                }
            }

            if (labelGroup.MemberCount > 0) {
                if (labelGroupMetadata.SummaryOnWrappedLine) {
                    labelGroup.Summary = [labelGroup.Summary.join(', ')];
                }
                labelGroups.push(labelGroup);
            }
        }

        var totalMemberCount = 0;
        $.each(labelGroups, function(labelGroupIndex, labelGroup) {
            totalMemberCount += labelGroup.MemberCount;
        });
        var moreSearchFieldsData = {
            LabelGroups: labelGroups,
            TotalMemberCount: totalMemberCount
        };
        return moreSearchFieldsData;
    };

    function hasFirstOrLastName(item) {
        return item.InputFirstName || item.InputLastName;
    };

    function hasInputNameOrLocation(item) {
        return item.InputName || item.InputGpid;
    };

    function removeMoreSearchFieldByInputName(inputName) {
        var metadata = getMoreSearchFieldsMetaData();
        var keyParts = urlParsingService.getKeyPartsOrNull(inputName);
        for (var i = 0; i < metadata.length; ++i) {
            var groupMetadata = metadata[i];
            if (groupMetadata.SubGroup && keyParts) {
                for (var subGroupIndex = 0; subGroupIndex < groupMetadata.SubGroup.length; ++subGroupIndex) {
                    var subGroup = groupMetadata.SubGroup[subGroupIndex];
                    if (subGroup.InputName == keyParts.prefix || subGroup.InputGpid == keyParts.prefix) {
                        subGroup.ExcludeList.push(keyParts.prefix + parseInt(keyParts.index || '0'));
                        return;
                    }
                }
            }
            else if (groupMetadata.InputName == inputName || groupMetadata.InputPlaceName == inputName) {
                metadata.splice(i, 1);
                return;
            }
        }
    }

    var moreSearchFieldsMetaDataStore = null;
    function getMoreSearchFieldsMetaData() {
        if (moreSearchFieldsMetaDataStore != null) return moreSearchFieldsMetaDataStore;
        moreSearchFieldsMetaDataStore = [
            {
                InputLabelPrefix: localizationService.get("AnyLabelSliderPrefix"),
                SubGroup: [
                    {
                        InputName: "msydy", /* Any Event */
                        InputGpid: "msypn",
                        MaxCount: 11,
                        StartIndex: 0,
                        ExcludeList: []
                    },
                    {
                        InputGpid: "mswpn",
                        MaxCount: 11,
                        StartIndex: 0,
                        ExcludeList: []
                    }
                ]
            },
            {
                InputLabelPrefix: localizationService.get("AlsoLivedInLabel"),
                SubGroup: [
                    {
                        InputName: "msrdy", /* Lived In Event (NA) */
                        InputGpid: "msrpn",
                        MaxCount: 11,
                        StartIndex: 0,
                        ExcludeList: []
                    }
                ]
            },
            {
                InputLabelPrefix: localizationService.get("MarriageEventLabel"),
                InputName: "msgdy", /* Marriage Date Year Event */
                InputPlaceName: "msgpn__ftp" /* Marriage Place Name */
            },
            {
                InputLabelPrefix: localizationService.get("ArrivalEventLabel"),
                InputName: "msady", /* Arrival Date Year Event */
                InputPlaceName: "msapn__ftp" /* Arrival Place Name */
            },
            {
                InputLabelPrefix: localizationService.get("DepartureEventLabel"),
                InputName: "msedy", /* Departure Date Year Event */
                InputPlaceName: "msepn__ftp" /* Departure Place Name */
            },
            {
                InputLabelPrefix: localizationService.get("MilitaryEventLabel"),
                InputName: "msidy", /* Military Date Year Event */
                InputPlaceName: "msipn__ftp" /* Military Place Name */
            },
            {
                InputLabelPrefix: localizationService.get("SlidersAnythingLabel"),
                InputName: "gskw" /* Keyword */
            },
            {
                InputLabelPrefix: localizationService.get("RaceLabelSliderPrefix"),
                InputName: "_83004002" /* Race */
            },
            {
                InputLabelPrefix: localizationService.get("GenderLabel"),
                InputName: "_83004003-n_xcl", /* Gender */
                Male: localizationService.get("Male"),
                Female: localizationService.get("Female")
            },
            {
                InputLabelPrefix: localizationService.get("ParentsSliderLabel"),
                SummaryOnWrappedLine: true,
                SubGroup: [
                    {
                        InputFirstName: "msfng", /* Father */
                        InputLastName: "msfns",
                        MaxCount: 1,
                        StartIndex: 0,
                        ExcludeList: []
                    },
                    {
                        InputFirstName: "msmng", /* Mother */
                        InputLastName: "msmns",
                        MaxCount: 1,
                        StartIndex: 0,
                        ExcludeList: []
                    }
                ]
            },
            {
                InputLabelPrefix: localizationService.get("SiblingsSliderLabel"),
                SummaryOnWrappedLine: true,
                SubGroup: [
                    {
                        InputFirstName: "msbng", /* Sibling */
                        MaxCount: 10,
                        StartIndex: 0,
                        ExcludeList: []
                    }
                ]
            },
            {
                InputLabelPrefix: localizationService.get("SpousesSliderLabel"),
                SummaryOnWrappedLine: true,
                SubGroup: [
                    {
                        InputFirstName: "mssng", /* Spouse */
                        InputLastName: "mssns",
                        MaxCount: 10,
                        StartIndex: 0,
                        ExcludeList: []
                    }
                ]
            },
            {
                InputLabelPrefix: localizationService.get("ChildrenSliderLabel"),
                SummaryOnWrappedLine: true,
                SubGroup: [
                    {
                        InputFirstName: "mscng", /* Child */
                        MaxCount: 10,
                        StartIndex: 0,
                        ExcludeList: []
                    }
                ]
            }
        ];
        return moreSearchFieldsMetaDataStore;
    };

    return {
        getMoreSearchFieldsData: getMoreSearchFieldsData,
        hasCollectionPriority: hasCollectionPriority,
        removeMoreSearchFieldByInputName: removeMoreSearchFieldByInputName
    };
}]);(function() {
    var sliderModule = angular.module('sliderWidgetModule', []);
    sliderModule.directive('sliderDirective', [function() {
        return {
            scope: {
                sliderItem: '=',
                sliderChange: '&',
            },
            link: function(scope, element, attrs) {
                function getSliderValue(notchNumber) {
                    if (notchNumber >= scope.sliderItem.NotchArray.length || notchNumber < 0) {
                        return null;
                    }
                    return scope.sliderItem.NotchArray[notchNumber].value;
                };
                var currentNotchNumber, sliderValueChangedInternally = false, sliderWidget = null;
                function getNotchNumber(value) {
                    var currentNotch;
                    for (var i = 0; i < scope.sliderItem.NotchArray.length; i++) {
                        currentNotch = scope.sliderItem.NotchArray[i];
                        if (currentNotch.value === value) {
                            return i;
                        }
                    }
                    return 0;
                };
                function notchChange(newNotchNumber) {
                    currentNotchNumber = newNotchNumber;
                    scope.sliderItem.InputExactValue = getSliderValue(currentNotchNumber);
                    sliderValueChangedInternally = true;
                    scope.$apply(function () {
                        scope.sliderChange();
                    });
                };
                function setupSlider() {
                    element.empty();
                    currentNotchNumber = getNotchNumber(scope.sliderItem.InputExactValue);
                    sliderWidget = element.slider({
                        startingNotch: currentNotchNumber,
                        notchCount: scope.sliderItem.NotchArray,
                        notchWidth: "small",
                        radioName: scope.sliderItem.InputExactName,
                        useCallouts: true,
                        handleAnimationType: "easeOutElastic",
                        handleAnimationTime: 400,
                        notchChange: notchChange,
                    });
                };
                setupSlider();
                scope.$watch('sliderItem.NotchArray.length', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        // Setup the slider notches anew.
                        setupSlider();
                    }
                });
                scope.$watch('sliderItem.InputExactValue', function(newValue, oldValue) {
                    if (!sliderValueChangedInternally && newValue !== oldValue) {
                        // Setup the slider again.
                        setupSlider();
                    }
                    sliderValueChangedInternally = false;
                });
            }
        };
    }]);
}());